<template>
    <div class="relative rounded-full border border-primary overflow-hidden h-9 bg-grey-100">
        <div class="bg-primary absolute inset-0 text-white z-10 whitespace-nowrap overflow-hidden text-lg flex items-center transition-all"
             :style="{'width': `${percentageComplete}%`, 'transition-duration': transitionDuration + 'ms', 'transition-delay': transitionDelay + 'ms'}"
        >
            <ProgressBarLabel
                class="pl-3"
                :label="label"
                :progress="percentageComplete"
                :count-duration="transitionDuration"
                :count-delay="transitionDelay"
            ></ProgressBarLabel>
        </div>

        <!-- Duplicate the label so we can nicely transition to it if progress bar is not full enough -->
        <ProgressBarLabel
            class="text-primary text-lg absolute px-3 py-1 inset-0"
            :label="label"
            :progress="percentageComplete"
            :count-duration="transitionDuration"
            :count-delay="transitionDelay"
        ></ProgressBarLabel>
    </div>
</template>

<script>
import ProgressBarLabel from "@/Components/ProgressBar/ProgressBarLabel";

export default {
    components: {
        ProgressBarLabel,
    },
    props: {
        label: String,
        progress: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 100
        },
        transitionDuration: Number,
        transitionDelay: Number
    },
    computed: {
        percentageComplete() {
            return Math.round(this.progress / this.max * 100);
        },
        computedLabel() {
            if (this.label) return `${this.label} - ${this.percentageComplete}%`;

            return `${this.percentageComplete}%`;
        },
    }
}
</script>

<style scoped>

</style>
